// 阿拉伯语
export default
{
 common: {
       notshow: 'لا تظهر اليوم',
 unit: 'USDT',
 day: 'يوم',
 week: 'أسبوع',
 save: 'حفظ',
 submit: 'تقديم',
 confirmtitle: 'تأكيد تنفيذ العملية',
 confirm: 'تأكيد',
 reset: 'إعادة تعيين',
 refresh: 'تحديث',
 copy: 'نسخ',
 copysuccessful: 'تم النسخ بنجاح',
 modify: 'تعديل',
 binding: 'ربط',
 finished: 'تم الانتهاء',
 canceled: 'تم الإلغاء',
 cancel: 'إلغاء',
 all: 'الكل',
 back: 'عودة',
 loading: 'جاري التحميل...',
 nomore: 'جميع السجلات',
 errortxt: 'فشل التحميل',
 loosing: 'الافراج عنها لتحديث...',
 pulling: 'اسحبها لتحديث...',
 nodata: 'لا يوجد سجلات في الوقت الحالي',
 buy: 'شراء',
 buyup: 'شراء ارتفاع',
 buydown: 'شراء انخفاض',
 sell: 'بيع',
 forserver: 'الرجاء استشارة خدمة العملاء',
 total: 'الإجمالي',
 status1: 'في انتظار التحقق',
 status2: 'مكتمل',
 status3: 'غير موافق',
 paytype1: 'TRC20',
 paytype2: 'ERC20',
 paytype3: 'تحويل بنكي',
 },
 footer: {
 home: 'الصفحة الرئيسية',
 market: 'السوق',
 exchange: 'عملات رقمية',
 options: 'خيارات',
 assets: 'الأصول',
 change: 'تحويل',
 recharge: 'إيداع',
 withdrawal: 'سحب',
 },
 home: {
 menu1: 'تداول الخيارات',
 menu1desc: 'دعم BTC/USDT إلخ',
 menu2: 'إيداع سريع',
 menu3: 'سحب',
 menu4: 'خدمة عملاء على الإنترنت',
 menu5: 'صرف فوري',
 menu6: 'قرض مساعد',
 menu7: 'تعدين بحجز الأموال',
 menu8: 'رهن',
 menu9: 'تحويل حساب',
 ranktitle: 'قائمة الزيادة',
 name: 'الاسم',
 price: 'السعر الأحدث',
 risefall: 'النسبة المئوية للزيادة أو الانخفاض',
 },
 register: {
 register: 'تسجيل',
 login: 'تسجيل الدخول',
 email: 'البريد الإلكتروني',
 phone: 'الرقم الهاتفي',
 accountplaceholder: 'الرجاء إدخال الحساب',
 emailplaceholder: 'الرجاء إدخال البريد الإلكتروني',
 phoneplaceholder: 'الرجاء إدخال الهاتف',
 pwdplaceholder: 'كلمة المرور 6-20 حرفًا أو رقمًا',
 pwdplaceholder1: 'كلمة المرور',
 agepwdplaceholder: 'الرجاء إدخال كلمة المرور مرة أخرى',
 agepwdplaceholder1: 'كلمتي المرور غير متطابقتين',
 invitecodeplaceholder: 'الرجاء إدخال رمز الدعوة',
 remember: 'تذكر كلمة المرور',
 fotget: 'نسيت كلمة المرور'
 },
 market: {
 title: 'السوق',
 all: 'الكل'
 },
 member: {
 reputation: 'الصدقة',
 identity_authentication: 'التحقق من الهوية',
 under_review: 'قيد المراجعة',
 certified: 'معتمد',
 awaiting_certification: 'في انتظار التحقق',
 binding_withdrawal_address: 'ربط عنوان السحب',
 currently_selected_currency: 'العملة المحددة حاليًا',
 withdrawal_address: 'عنوان السحب',
 sharing_link: 'رابط مشاركتي',
 my_promotion_code: 'رمز الترويج الخاص بي',
 promotion_code: 'رمز الترويج',
 system_message: 'رسالة النظام',
 night_mode: 'الوضع الليلي',
 security_center: 'مركز الأمان',
 seted: 'تم الإعداد',
 noset: 'لم يتم الإعداد',
 login_password: 'كلمة مرور الدخول',
 transaction_password: 'كلمة مرور السحب',
 app_download: 'تنزيل التطبيق',
 log_out: 'تسجيل الخروج',
        aboutus: 'مقدمة الموقع'
 },
 identity: {
 title: 'التحقق من الهوية',
 name: 'الاسم',
 nameplaceholder: 'الرجاء إدخال الاسم الحقيقي',
 uploader: 'تحميل صورة الهوية',
 tip1: 'تحميل وجه الهوية',
 tip2: 'تحميل ظهر الهوية'
 },
 address: {
 title: 'ربط عنوان السحب',
 bType: 'العملة المحددة حاليًا',
 address: 'عنوان السحب',
 addressplaceholder: 'الرجاء إدخال عنوان السحب'
 },
 security: {
 title: 'مركز الأمان',
 modifypwd: 'كلمة مرور الدخول',
 resetlegalpwd: 'كلمة مرور السحب',
 loginpwd: 'كلمة مرور الدخول الجديدة',
 pwdage: 'تأكيد كلمة المرور',
 loginpwdplaceholder: 'الرجاء إدخال كلمة المرور الحالية',
 loginnewpwdplaceholder: 'الرجاء إدخال كلمة المرور الجديدة',
 moneypwd: 'الرجاء إدخال كلمة مرور السحب',
 pwdageplaceholder: 'الرجاء إدخال كلمة المرور مرة أخرى'
 },
 trade: {
 title: 'تداول العملات الرقمية',
 price: 'السعر',
 num: 'الكمية',
 entrust: 'الطلبات الحالية',
 clinch: 'المعاملات الفعلية',
 used: 'متاح',
 buyed: 'يمكن الشراء',
 amount: 'القيمة',
 limitprice: 'السعر المحدد',
 marketprice: 'السعر السوقي',
 forprice: 'بأفضل سعر حالي',
 errorMoney: 'الرصيد المتاح غير كاف',
 priceerror: 'الرجاء إدخال سعر الطلب',
 numerror: 'الرجاء إدخال كمية الطلب',
 moneyerror: 'الرجاء إدخال مبلغ الطلب'
 },
 assets: {
 allconvert: 'إجمالي الأصول المحوسبة',
 usenum: 'متاح',
 freeze: 'مجمد',
 convert: 'محوسب',
 tab1: 'الأصول',
 tab11: 'إجمالي الأصول المحوسبة',
 tab12: 'خيارات المحوسبة',
 tab13: 'الأموال المحوسبة',
 tab14: 'الكميات المحوسبة',
 tab2: 'خيارات',
 tab21: 'حساب الخيارات',
 tab3: 'الأموال',
 tab31: 'حساب الأموال',
 tab4: 'الكميات',
 tab41: 'حساب الكميات',
 tbhead1: 'سجلات المالية',
 tbhead2: 'سجلات السحب',
 tbhead3: 'سجلات الإيداع',
 tbhead4: 'سجلات التحويل',
 rcdnum: 'الكمية',
 rcd: 'سجل',
 rcdtime: 'الوقت',
 rcdstatus: 'الحالة',
 rcddesc: 'الملاحظة',
 rcdaddress: 'عنوان الإيداع'
 },
 change: {
 title: 'تحويل',
 from: 'من {name}',
 to: 'إلى {name}',
 frmtitle: 'كمية التحويل',
 inputplaceholder: 'الرجاء إدخال كمية التحويل',
 btntxt: 'تحويل'
 },
 recharge: {
 title: 'إيداع',
 bType: 'العملة الحالية',
 address: 'عنوان الإيداع',
 token: 'دليل الدفع',
 tokenplaceholder: 'الرجاء تحميل دليل الدفع',
 num: 'الكمية',
 numplaceholder: 'الرجاء إدخال الكمية',
 btn: 'تقديم للمراجعة',
 bankname: 'اسم البنك',
 bankno: 'رقم البنك',
 accountname: 'اسم الحساب المستلم',
 bankaddress: 'عنوان البنك',
 bankcode: 'رمز التحويل البنكي',
 companyaddress: 'عنوان الشركة'
 },
 withdrawal: {
 title: 'سحب',
 frmtitle1: 'الكمية',
 frmplaceholder1: 'الكمية يجب أن تكون بين {min} - {max}',
 frmtitle2: 'كلمة مرور السحب',
 frmplaceholder2: 'الرجاء إدخال كلمة مرور السحب',
 getnum: 'الكمية المستلمة',
 fee: 'الرسوم',
 btn: 'سحب'
 },
 exchangeb: {
 title: 'صرف',
 account: 'الحساب',
 btn: 'صرف',
 numerror: 'الرجاء إدخال كمية الصرف'
 },
 option: {
 title: 'خيارات',
 typetitle: 'عقد ثانية',
 listtitle: 'مراكز التحطيم',
 kline: 'خط K',
 high: 'الارتفاع',
 low: 'الانخفاض',
 nums: '24 ساعة',
 time: 'الوقت',
 transaction: 'طريقة التداول',
 quantity: 'كمية فتح',
 quantityerror: 'الرجاء إدخال كمية فتح',
 times: 'وقت فتح',
 times1: 'وقت التسوية',
 account: 'رصيد الحساب',
 buyup: 'شراء ارتفاع',
 buydown: 'شراء انخفاض',
 tab1: 'قائمة مراكز التحطيم',
 tab2: 'سجل الطلبات',
 num: 'الكمية',
 price1: 'سعر الشراء',
 price2: 'سعر التداول',
 profitandloss: 'الأرباح أو الخسائر المتوقعة',
 profitandloss1: 'الأرباح أو الخسائر',
 countdown: 'العداد التنازلي',
 waitfinish: 'في انتظار التسوية',
 finishing: 'جاري التسوية...',
 finished: 'تم التسوية',
 order_price: 'السعر الحالي',
 order_cycle: 'الدورة',
 order_type: 'النوع',
 order_money: 'المبلغ',
 order_time: 'فتح',
 order_get: 'الأرباح',
 order_btn: 'استمر في الطلب'
 },
 tradelst: {
 title: 'طلباتي',
 tab1: 'طلبات',
 tab2: 'معاملات مكتملة',
 tab3: 'ملغاة',
 usdtnum: ''
 },

 loans: {
       repayment:'سداد القرض',
 title: 'قرض مساعد',
 order_tab: 'طلبات القرض',
 pro_tab: 'منتجات القرض',
 Institution: 'جهة الإعارة',
 Amount: 'المبلغ',
 DailyInterest: 'الفائدة اليومية',
 RepaymentPeriod: 'مدة السداد',
 Application: 'تقديم طلب القرض',
 orderno: 'رقم الطلب',
 AllInterest: 'إجمالي الفائدة',
 RepaymentDate: 'تاريخ السداد',
 RepaymentMethod: 'طريقة السداد',
 Onetime: 'مرة واحدة',
 Expected_loan_amount: 'المبلغ المتوقع للقرض',
 Expected_loan_amounterror: 'المبلغ يجب أن يكون بين {min} - {max}',
 imgplaceholdr: 'إعارة ائتمانية (الرجاء التأكد من وضوح الصورة)',
 icon1: 'تحميل وجه البطاقة الشخصية',
 icon2: 'تحميل ظهر البطاقة الشخصية',
 icon3: 'تحميل صورة بطاقة الشخصية بحوزتك',
 status1: 'قيد التقديم',
 status2: 'تم الموافقة',
 status3: 'تم الرفض',
 },

 lockming: {
 title: 'تعدين بحجز الأموال',
 order_tab: 'طلبات الآلات',
 pro_tab: 'سوق الآلات',
 locknum: 'أقل كمية لحجز الأموال',
 getforday: 'العائد / يوم',
 days: 'الأيام',
 estimation: 'التقدير للمكاسب',
 real: 'المكاسب الحقيقية',
 balance: 'رصيد المحفظة',
 nums: 'كمية الحجز',
 tolockming: 'حجز الأموال',
 stime: 'وقت البداية',
 etime: 'وقت النهاية',
 },

 transfer: {
 title: 'تحويل حساب',
 searchtxt: 'الرجاء إدخال رقم الحساب المقابل',
 ReceivingAccount: 'معلومات حساب المستلم',
 toaccount: 'الحساب',
 confirmtxt: 'الرجاء النقر للتأكيد على حساب المستلم',
 confirmedtxt: 'تم تأكيد حساب المستلم',
 numtxt: 'كمية التحويل',
 numerror: 'الرجاء إدخال كمية التحويل',
 fee: 'تحويل داخلي بدون رسوم',
 ArrivalTime: 'وقت الوصول',
 Immediately: 'الوصول الفوري',
 realnum: 'الكمية الفعلية الوصول',
 btn: 'تأكيد التحويل',
 transfering: 'جاري التحويل',
 orderNo: 'رقم الطلب',
 stime: 'وقت التحويل',
 etime: 'وقت الوصول',
 receiving: 'حساب المستلم',
 type: 'العملة',
 num: 'كمية التحويل',
 arrivalnum: 'الكمية المسجلة'
 },

 staking: {
 title: 'رهن',
 record: 'سجل',
 getforyear: 'العائد السنوي المرجعي',
 time: 'مدة الاستثمار',
 snum: 'الحد الأدنى للمشاركة',
 snumerror: 'الرجاء إدخال الحد الأدنى للمشاركة',
 snumerror1: 'الحد الأدنى للمشاركة يجب أن يكون {num}',
 join: 'المشاركة فورية',
 opentime: 'وقت فتح الحساب',
 money: 'المبلغ المسجل',
 days: 'الدورة',
 recordget: 'العائد السنوي',
 gets: 'المكاسب',
 stime: 'تاريخ البداية',
 etiem: 'تاريخ النهاية',
 redeemStaking: 'إلغاء',
 status0: 'في رهن',
 status1: 'نهاية الطلب',
 status2: 'استرداد الطلب',
 },
 bank:{
       title: 'ربط البطاقة البنكية',
       bankName: 'اسم البنك',
       bankNameError: 'الرجاء إدخال اسم البنك',
       usrName: 'صاحب البطاقة',
       usrNameError: 'الرجاء إدخال صاحب البطاقة',
       cardCode: 'رقم البطاقة البنكية',
       cardCodeError: 'الرجاء إدخال رقم البطاقة البنكية',
       towallet: 'سحب العملات إلى المحفظة',
       tobank: 'سحب العملات إلى البطاقة البنكية',
       sendcode: 'إرسال رمز التحقق',
       sended: 'إعادة الإرسال بعد {num} ثانية',
       verify_code: 'الرجاء إدخال رمز التحقق من البريد الإلكتروني'
     }
     
}
